// External Imports
import { useContext, useState } from "react";
import { UtilityContext } from "../../context/util-context";
import { requestAdminAPI } from "../../api/posh-api";
import AddSubscription from "./AddSubscription";
import InvoiceModal from "../payments-page/InvoiceModal";

// Internal Imports

/** ========================================================================
 * * CustomerButtons Component
 * This component renders buttons for actions on a customer.
 * ========================================================================== */

export default function CustomerButtons({ customer, refresh = () => {} }) {
  // Load Context
  const { navigate } = useContext(UtilityContext);

  // Initialize States
  const [loading, setLoading] = useState(false);
  const [editPlan, setEditPlan] = useState(false);
  const [sendInvoice, setSendInvoice] = useState(false);

  /* =================== SEND ACH SETUP LINK =================== */
  const sendACHSetupLink = async () => {
    try {
      setLoading(true);

      // Get ACH setup link from API
      const hostedUrl = await requestAdminAPI("setup-ach", {
        customerId: customer.id,
      });

      // Send message to customer with ACH setup link
      const message = `Please click the following link to set up ACH: ${hostedUrl.url}`;
      await requestAdminAPI("send-message", {
        customerId: customer.id,
        message,
      });

      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  /* =================== MANAGE DO NOT RENT STATE =================== */
  const manageDNR = async () => {
    try {
      setLoading(true);
      await requestAdminAPI("manage-dnr", {
        customerId: customer.id,
        add: !customer.doNotRent,
      });
      refresh();
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div className="grid gap-4">
        {Array.from({ length: 5 }, (_, i) => (
          <div key={i} className="h-10 btn-secondary animate-pulse"></div>
        ))}
      </div>
    );

  return (
    <div className="grid gap-2 text-sm">
      <AddSubscription
        open={editPlan}
        setOpen={setEditPlan}
        customer={customer}
        refresh={refresh}
      />
      <InvoiceModal
        open={sendInvoice}
        setOpen={setSendInvoice}
        customerId={customer.id}
      />
      <div onClick={() => setSendInvoice(true)} className="btn-secondary">
        Send Invoice
      </div>
      <div
        onClick={(e) => navigate(`support?id=${customer.id}`, e)}
        className="btn-secondary"
      >
        Send Message
      </div>
      <div onClick={() => sendACHSetupLink()} className="btn-secondary">
        Send ACH Setup Link
      </div>
      {!customer?.booking && (
        <div
          onClick={(e) =>
            navigate(`/bookings/add?customerId=${customer.id}`, e)
          }
          className="btn-secondary"
        >
          Add Booking
        </div>
      )}
      <div
        id="edit-subscription"
        onClick={() => setEditPlan(true)}
        className="btn-secondary"
      >
        {customer?.plan ? "Edit Subscription" : "Add Subscription"}
      </div>
      {!customer?.doNotRent ? (
        <div onClick={manageDNR} className="btn-warning">
          Add to DNR
        </div>
      ) : (
        <div onClick={manageDNR} className="btn-primary">
          Remove from DNR
        </div>
      )}
    </div>
  );
}
